import Cookies from "js-cookie";
import { getToken } from "../../firebase";
import { apiManager } from "../api-manager";
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const signOut = async () => {
  const token = await getToken();
  if (!token) {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    return { success: true };
  }
  let res = await apiManager.patch("/admin/logout", { fcm: token });
  Cookies.remove("accessToken");
  Cookies.remove("refreshToken");
  return res;
};


export const useSignOut = () =>
  useMutation({
    mutationFn: async () => {
      const token = await getToken();
      if (!token) {
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        return;
      }
      await apiClient.patch(ENDPOINTS.AUTH.LOGOUT, { fcm: token });
      Cookies.remove("accessToken");
      Cookies.remove("refreshToken");
    },
  });
